module.exports = __webpack_public_path__ + "img/katarina_outside_16.43b39b0b.jpg";